import { render } from "./Servers.vue?vue&type=template&id=5cf1ecf3&scoped=true"
import script from "./Servers.vue?vue&type=script&lang=js"
export * from "./Servers.vue?vue&type=script&lang=js"

import "./Servers.vue?vue&type=style&index=0&id=5cf1ecf3&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf1ecf3"]])

export default __exports__